import CKEditor from './ckeditor/ckeditor';
import MCDatepicker from 'mc-datepicker';
import * as bootstrap from 'bootstrap';
import TomSelect from 'tom-select';
import Swal from 'sweetalert2';
import Noty from 'noty';
import Helper from './helper';

window.CKEditor = CKEditor;
window.TomSelect = TomSelect;
window.MCDatepicker = MCDatepicker;

window.editorConfig = window.editorConfig || {};

class SterkNaarWerk {
    constructor() {
        this.init();
    }

    init() {
        this.initTooltip();
        this.initTableEvents();
        this.initLivewireListeners();
    }

    /**
     * Show a notification to the user
     *
     * @param text
     *
     * @param status
     */
    showNotification (text, status) {
        new Noty({
            timeout: 5000,
            text: text,
            type: status,
            layout: 'topRight',
            theme: 'bootstrap-v4',
        }).show();
    }

    /**
     * Initialize Bootstrap tooltips
     */
    initTooltip (container = document) {
        let tooltipTriggerList = [].slice.call(container.querySelectorAll('[data-bs-toggle="tooltip"]'));

        tooltipTriggerList.map(tooltipTriggerEl => {
            return new bootstrap.Tooltip(tooltipTriggerEl, {
                trigger: 'hover'
            })
        });

        Livewire.hook('morphed', ({ el, component }) => {
            // Check if the element is a Livewire component
            if (el.hasAttribute('wire:id')) {
                // Re-initialize tooltips for the new content within the component
                el.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
                    // If the element is currently hovered, skip it
                    if (el.matches(':hover')) {
                        return;
                    }

                    const existingTooltip = bootstrap.Tooltip.getInstance(el);

                    if (existingTooltip) {
                        // Hide and dispose of the existing tooltip instance
                        existingTooltip.hide();
                        existingTooltip.dispose();
                    }

                    // Initialize a new tooltip for the element
                    new bootstrap.Tooltip(el, {
                        trigger: 'hover'
                    });
                });
            }
        });
    }

    initTableEvents() {
        Helper.bindEventListener(document, 'click', 'tr[data-url] > td:not([class*="actions"])', function () {
            let parent = this.closest('tr');

            let target = parent.getAttribute('data-tr-target') === '_blank'
                ? '_blank'
                : '_self'

            window.open(parent.dataset.url, target);
        });
    }

    /**
     * Initialize Livewire listeners
     */
    initLivewireListeners() {
        Livewire.on('notify', ([message]) => {
            this.showNotification(message.text, message.type);
        });
    }
}

window.addEventListener('load', () => new SterkNaarWerk());

window.addEventListener('alpine:init', () => {
    Alpine.data('confirmAction', ({
        event = null,     // Event name to dispatch
        id = null,        // Optional model ID
        title = '',       // Dialog title
        text = '',        // Optional dialog text
        type = 'info',    // Alert type
        callback = null,  // Optional custom callback
        params = {}       // Additional parameters for basic dispatch
    }) => ({
        confirm() {
            Swal.fire({
                title              : title,
                text               : text,
                icon               : type,
                showCancelButton   : true,
                confirmButtonColor : '#17102C',
                cancelButtonColor  : '#859FF4',
                cancelButtonText   : 'Annuleren',
                confirmButtonText  : 'Doorgaan'
            }).then((result) => {
                if (result.value) {
                    if (typeof callback === 'function') {
                        // Advanced: Use custom callback
                        callback(result);
                    }
                    else if (event) {
                        // Simple: Use standard dispatch with model ID and optional params
                        const payload = { ...params };

                        if (id !== null) {
                            payload.id = id;
                        }

                        Livewire.dispatch(event, payload);
                    }
                }
            });
        }
    }));
});
